
<template>
    <section class="home-main-content">

      <!-- post-type start-->
      <post-type class="post-type"></post-type>
      <!-- post-type end-->

      <!-- all post & story -->
      <section class="posts-wrap">

        <div class="row grid">
            <div class="item" 
                 v-images-loaded.on.progress="imageProgress"
                 v-for="(data, index) in posts" 
                 :key="index">


              <!-----------------------
                story-card area start
              ------------------------->
              <div class="post-single-wrap" v-if="data.type=='story-card'">

                <div class="card-header">
                    <router-link to="/" class="autohor-details">
                      <img v-if="data.author.proPic" :src="require(`@/assets/images/${data.author.proPic}`)" :alt="data.name" />
                      <div class="author-name">
                        <h2>
                            {{ data.author.name }} <img v-if="data.author.verified==true" src="../../assets/icon/varified-icon.svg" alt="varified">
                        </h2>
                        <p>@{{ data.author.userName }}</p>
                      </div>
                    </router-link>
                    <base-dropdown class="post-setting dropdown-sm">
                        <div class="dropdown-sm-icon" slot="title">
                          <button class="search-btn dropdown-sm">
                            <img src="../../assets/icon/dot-toggle.svg" alt="varified">
                          </button>
                        </div>
                        <template>
                            <router-link to="/recently-used" class="dropdown-item ">
                                Recently used
                            </router-link>
                            <router-link to="/image-collections" class="dropdown-item">
                                Image Collections
                            </router-link>
                            <router-link to="/themes" class="dropdown-item ">
                               Themes
                            </router-link>
                        </template>
                    </base-dropdown>
                </div><!-- /. card-header -->

                <div class="card-body story-desc-wrap">
                  <a @click="postModal">
                    <img :src="require(`@/assets/images/posts-img/${data.img}`)" :alt="data.name" />
                    <div class="story-description">
                      <h2>{{ data.title }}</h2>
                      <p>{{ data.desc }}</p>
                    </div>
                  </a>
                </div><!-- /. card-body -->

                <div class="card-footer footer-social">
                  <ul>
                     <reaction-emoji :postReaction="data.postReaction"></reaction-emoji>                   
                    <li>
                      <img class="share-icon" src="../../assets/icon/repeat.svg" alt="share-icon" />
                      <span>4</span>
                    </li>
                    <li>
                      <img class="comment-icon" src="../../assets/icon/message-circle.svg" alt="comment-icon" />
                      <span>{{  numberFormat(data.postComments ? data.postComments.length : 0) }}</span>
                    </li> 
                  </ul>
                  <div class="share-btn">
                    <img class="share-story" src="../../assets/icon/share-icon.svg" alt="share-story" />
                    <span>Share</span>
                  </div>
                </div><!-- /. card-footer -->
              </div>
              <!-----------------------
                story-card area end
              ------------------------->


              <!-----------------------
                series-card area start 
              ------------------------->
              <div class="post-single-wrap story-wrapper" v-if="data.type=='series-card'">

                <div class="card-header">
                    <router-link to="/" class="autohor-details">
                      <div class="author-name">
                        <h2>
                            {{ data.author.name }}
                        </h2>
                        <p><i>by @{{ data.author.userName }}</i></p>
                      </div>
                    </router-link>
                    <base-dropdown class="post-setting dropdown-sm">
                        <div class="dropdown-sm-icon" slot="title">
                          <button class="search-btn dropdown-sm">
                            <img src="../../assets/icon/dot-toggle.svg" alt="varified">
                          </button>
                        </div>
                        <template>
                            <router-link to="/recently-used" class="dropdown-item ">
                                Recently used
                            </router-link>
                            <router-link to="/image-collections" class="dropdown-item">
                                Image Collections
                            </router-link>
                            <router-link to="/themes" class="dropdown-item ">
                               Themes
                            </router-link>
                        </template>
                    </base-dropdown>
                </div><!-- /. card-header -->

                <div class="card-body story-desc-wrap">
                  <router-link :to="{ name: 'series-details'}">
                    <img :src="require(`@/assets/images/posts-img/${data.img}`)" :alt="data.name" />
                  </router-link>
                </div><!-- /. card-body -->

                <div class="card-footer story-footer">
                  <div class="story-footer-desc">
                    <router-link :to="{ name: 'series-details'}">
                      <p>{{data.desc}}</p>
                    </router-link>
                  </div>
                  <ul>
                    <li>
                      <img class="heart-icon" src="../../assets/icon/eye.svg" alt="eye-icon" />
                      <span>{{ data.postStatistic.reads }} Reads</span>
                    </li>
                    <li>
                      <img class="heart-icon" src="../../assets/icon/heart-fill.svg" alt="heart-icon" />
                      <span>{{ data.postStatistic.voted }} Voted</span>
                    </li>
                    <li>
                      <img class="heart-icon" src="../../assets/icon/episode.svg" alt="episode-icon" />
                      <span>{{ data.postStatistic.episode }} Episode</span>
                    </li>
                    <li>
                      <img class="share-story" src="../../assets/icon/share-icon.svg" alt="share-story" />
                      <span>Share</span>
                    </li>
                  </ul>

                  <div class="story-tag" v-if="data.tags">
                    <button v-for="(data, key) in data.tags" :key="key">{{data}}</button>
                  </div>
                </div><!-- /. card-footer -->
              </div>
              <!-----------------------
                series-card area end 
              ------------------------->


              <!-----------------------
                addPost area start 
              ------------------------->
              <router-link to="/" class="post-single-wrap addPost" v-if="data.type=='addPost'"  :style="[data.bgColor ? {'background': data.bgColor } : {'background': '#2d99ff'}]">
                  <h2>{{ data.title }}</h2>
                  <p>{{ data.desc }}</p>
                  <p v-if="data.desc.length > 180" class="viewMore">
                    View more contests
                  </p>
              </router-link>
              <!-----------------------
                addPost area end 
              ------------------------->


              <!-----------------------
                shared-post start 
              ------------------------->
              <div class="post-single-wrap" v-if="data.type=='shared-post'">

                <div class="card-header">
                    <router-link to="/" class="autohor-details">
                      <img v-if="data.author.proPic" :src="require(`@/assets/images/${data.author.proPic}`)" :alt="data.name" />
                      <div class="author-name">
                        <h2>
                            {{ data.author.name }} 
                            <img v-if="data.author.verified==true" src="../../assets/icon/varified-icon.svg" alt="varified">
                        </h2>
                        <p>@{{ data.author.userName }}</p>
                      </div>
                    </router-link>
                    <base-dropdown class="post-setting dropdown-sm">
                        <div class="dropdown-sm-icon" slot="title">
                          <button class="search-btn dropdown-sm">
                            <img src="../../assets/icon/dot-toggle.svg" alt="varified">
                          </button>
                        </div>
                        <template>
                            <router-link to="/recently-used" class="dropdown-item ">
                                Recently used
                            </router-link>
                            <router-link to="/image-collections" class="dropdown-item">
                                Image Collections
                            </router-link>
                            <router-link to="/themes" class="dropdown-item ">
                               Themes
                            </router-link>
                        </template>
                    </base-dropdown>
                </div><!-- /. card-header -->

                <!-- shared post content start -->
                <div class="share-desc">
                  <h3>{{ data.title }}</h3>
                </div>
                <div class="share-post">
                  <div class="card-header">
                      <router-link to="/" class="autohor-details">
                        <img v-if="data.sharedPost && data.sharedPost.originalAuthor.proPic" :src="require(`@/assets/images/${data.sharedPost.originalAuthor.proPic}`)" :alt="data.sharedPost.originalAuthor.proPic" />
                        <div class="author-name">
                          <h2>
                              {{ data.sharedPost.originalAuthor.name }}
                              <img v-if="data.sharedPost.originalAuthor.verified==true" src="../../assets/icon/varified-icon.svg" alt="varified">
                          </h2>
                          <p>@{{ data.sharedPost.originalAuthor.userName }}</p>
                        </div>
                      </router-link>
                  </div><!-- /. card-header -->

                  <div class="card-body story-desc-wrap">
                    <img :src="require(`@/assets/images/posts-img/${data.sharedPost.img}`)" :alt="data.sharedPost.img" />
                    <div class="story-description">
                      <h2>{{ data.sharedPost.title }}</h2>
                      <p>{{ data.sharedPost.desc }}</p>
                    </div>
                  </div><!-- /. card-body -->

                  <div class="card-footer footer-social">
                    <ul>
                      <reaction-emoji :postReaction="data.postReaction"></reaction-emoji>                  
                      <li>
                        <img class="share-icon" src="../../assets/icon/repeat.svg" alt="share-icon" />
                        <span>4</span>
                      </li>
                      <li>
                        <img class="comment-icon" src="../../assets/icon/message-circle.svg" alt="comment-icon" />
                        <span>{{  numberFormat(data.postComments ? data.postComments.length : 0) }}</span>
                      </li>  
                    </ul>
                    <div class="share-btn">
                      <img class="share-story" src="../../assets/icon/share-icon.svg" alt="share-story" />
                      <span>Share</span>
                    </div>
                  </div><!-- /. card-footer -->
                </div>
                <!-- shared post content end -->
              </div>
              <!-----------------------
                shared-post end 
              ------------------------->


              <!-----------------------
                sliding post area start 
              ------------------------->
              <div class="post-single-wrap slider-post" v-if="data.type=='slider-post'">
                <div class="card-body">
                  <h2>{{ data.title }}</h2>
                  <p>{{ data.desc }}</p>
                  <div class="slide-box">
                    <router-link to="/" class="slide-box-single"
                         v-for="(boxData,boxIndex) in data.sliderCat" 
                         :key="boxIndex" 
                         :style="[boxData.bgColor ? {'background': boxData.bgColor } : {'background': '#2d99ff'}]
                         ">
                      <img :src="require(`@/assets/icon/${boxData.pattern}`)" alt="img">
                      <h3>{{ boxData.name }}</h3>
                    </router-link>
                  </div>
                </div><!-- /. card-body -->
              </div>
              <!-----------------------
                general post area end 
              ------------------------->

            </div><!-- /. post single -->
        </div>

      </section>


      <post-details-modal v-if="postModal" :postData="post"></post-details-modal>
    </section>
</template>

<script>

import { EventBus } from '../../main';
import Isotope from 'isotope-layout';
import imagesLoaded from 'vue-images-loaded';

export default {
  name: "home-main-content",

  data(){
    return{
      isotope: null,
      counter:0,
      post:{
          id:1,
          type: 'story-card',
          title: 'The Hidden Story of Charlie Chaplin',
          img: 'p1.jpeg',
          desc: 'Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry\'s standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum',
          author:{
            name: 'Dara Adhelia',
            userName:'daracantik',
            proPic: 'f1.png',
            verified: true
          },
          postReaction:[
            {
              userId:1,
              reaction:'love'
            },
            {
              userId:2,
              reaction:'wow'
            }
          ],
          postComments:[
            {
              userId:1,
              comment:"Comment goes to here.."
            },
            {
              userId:2,
              comment:"Comment goes to here.."
            },
            {
              userId:3,
              comment:"Comment goes to here.."
            }
          ],

      },
      
      posts:[
        {
          id:1,
          type: 'story-card',
          title: 'What is Lorem Ipsum?',
          img: 'p1.jpeg',
          desc: 'Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry\'s standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum',
          author:{
            name: 'Dara Adhelia',
            userName:'daracakep',
            proPic: 'f1.png',
            verified: true
          },
          postReaction:[
            {
              userId:1,
              reaction:'love'
            },
            {
              userId:2,
              reaction:'wow'
            }
          ],
          postComments:[
            {
              userId:1,
              comment:"Comment goes to here.."
            },
            {
              userId:2,
              comment:"Comment goes to here.."
            },
            {
              userId:3,
              comment:"Comment goes to here.."
            }
          ],

        },
        {
          id:2,
          type: 'series-card',
          img: 'p2.jpeg',
          desc: 'Story series about Tom Riddle aka Lord Voldemort, a huge villain of Harry Potter and The Party Hellows',

          author:{
            name: 'Voldemort',
            userName: 'daracakep'
          },
          postStatistic:{
            reads:'12.2k',
            voted: '2.2',
            episode: '6'
          },
          tags:['pikachu','pokemon','detective pikachu','poke']
        },
        {
          id:3,
          type: 'addPost',
          title: 'Daily Prompt: Sidewalk',
          bgColor: '#826AF9',
          desc: 'Tap here to make a story about Sidewalk and a win chance to get featured!'
        },
        {
          id:4,
          type: 'shared-post',
          title: 'Hi! Let’s check this story! It’s make me cry',
          author:{
            name: 'Dara Adhelia',
            userName: 'daracakep',
            proPic: 'avatar.png',
            verified: true
          },
          sharedPost:{
            id: 1,
            title: 'What is Lorem Ipsum?',
            img: 'p1.jpeg',
            desc: 'Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry\'s standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum',
            originalAuthor:{
              name: 'Jon Doe',
              userName: 'jondoe',
              proPic: 'f4.png',
              verified: true
            }
          },
          postReaction:[
            {
              userId:1,
              reaction:'love'
            },
            {
              userId:2,
              reaction:'wow'
            },
            {
              userId:3,
              reaction:'laughing'
            }
          ],
          postComments:[
            {
              userId:1,
              comment:"Comment goes to here.."
            },
            {
              userId:2,
              comment:"Comment goes to here.."
            },
            {
              userId:3,
              comment:"Comment goes to here.."
            }
          ],
        },
        {
          id:5,
          type: 'story-card',
          title: 'What is Lorem Ipsum?',
          img: 'p1.jpeg',
          desc: 'Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry\'s standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum',

          author:{
            name: 'Shuvo sd',
            userName: 'daracakep',
            proPic: 'f3.png',
            verified: true
          },
          postReaction:[
            {
              userId:1,
              reaction:'love'
            },
            {
              userId:2,
              reaction:'crying'
            },
            {
              userId:3,
              reaction:'laughing'
            },
            {
              userId:4,
              reaction:'wow'
            }
          ],
          postComments:[
            {
              id:1,
              comment:"Comment goes to here.."
            },
            {
              id:2,
              comment:"Comment goes to here.."
            },
            {
              id:3,
              comment:"Comment goes to here.."
            }
          ]

        },
        {
          id:6,
          type: 'story-card',
          title: 'What is Lorem Ipsum?',
          img: 'p1.jpeg',
          desc: 'Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry\'s standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum',
          author:{
            name: 'Jon Doe',
            userName:'jondoe',
            proPic: 'f4.png',
            verified: true
          },

          postReaction:[
            {
              userId:1,
              reaction:'love'
            },
            {
              userId:2,
              reaction:'wow'
            },
            {
              userId:3,
              reaction:'laughing'
            }
          ],
          postComments:[
            {
              userId:1,
              comment:"Comment goes to here.."
            },
            {
              userId:2,
              comment:"Comment goes to here.."
            },
            {
              userId:3,
              comment:"Comment goes to here.."
            }
          ],
        },
        {
          id:7,
          type: 'addPost',
          title: 'When the Villain Prevails Contest',
          bgColor: '#2d99ff',
          desc: 'Tap here to participate in this contest and get more exposure! Aren’t you tired of the good guys winning all the time? Well it’s time to give the vallains some credit in this contesdf…'
        },
        {
          id:8,
          type: 'series-card',
          img: 'p2.jpeg',
          desc: 'Story series about Tom Riddle aka Lord Voldemort, a huge villain of Harry Potter and The Party Hellows',

          author:{
            name: 'Voldemort',
            userName: 'daracakep'
          },
          postStatistic:{
            reads:'12.2k',
            voted: '2.2',
            episode: '6'
          },
          tags:['pikachu','pokemon','detective pikachu','poke']
        },
        {
          id:9,
          type: 'slider-post',
          title: 'Daily Prompt: Sidewalk',
          desc: 'Follow your passion to see stories in your favorite fandoms, genres, and more!',
          sliderCat: [
            {
              pattern:'bg-pattern.png',
              bgColor:'radial-gradient(circle, #8DAAFD, #9BDFED)',
              name: 'Thoughts'
            },
            {
              pattern:'bg-pattern2.png',
              bgColor:'radial-gradient(circle, #FC9FE1, #FFDDF5)',
              name: 'Horror'
            },
            {
              pattern:'bg-pattern3.png',
              bgColor:'radial-gradient(circle, #70E0A1, #DDFBA5)',
              name: 'Love'
            },
            {
              pattern:'bg-pattern.png',
              bgColor:'radial-gradient(circle, #998BF3, #D6BBFD)',
              name: 'Romance'
            },
            {
              pattern:'bg-pattern.png',
              bgColor:'radial-gradient(circle, #8DAAFD, #9BDFED)',
              name: 'Thoughts'
            },
            {
              pattern:'bg-pattern2.png',
              bgColor:'radial-gradient(circle, #FC9FE1, #FFDDF5)',
              name: 'Horror'
            },
            {
              pattern:'bg-pattern3.png',
              bgColor:'radial-gradient(circle, #70E0A1, #DDFBA5)',
              name: 'Love'
            },
            {
              pattern:'bg-pattern.png',
              bgColor:'radial-gradient(circle, #998BF3, #D6BBFD)',
              name: 'Romance'
            }
          ]
        },
        {
          id:10,
          type: 'story-card',
          title: 'What is Lorem Ipsum?',
          img: 'p1.jpeg',
          desc: 'Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry\'s standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum',
          author:{
            name: 'Dara Adhelia',
            userName:'daracakep',
            proPic: 'f1.png',
            verified: true
          },

          postReaction:[
            {
              userId:1,
              reaction:'love'
            },
            {
              userId:2,
              reaction:'wow'
            },
            {
              userId:3,
              reaction:'laughing'
            }
          ],
          postComments:[
            {
              userId:1,
              comment:"Comment goes to here.."
            },
            {
              userId:2,
              comment:"Comment goes to here.."
            },
            {
              userId:3,
              comment:"Comment goes to here.."
            }
          ],
        },
        {
          id:11,
          type: 'shared-post',
          title: 'Hi! Let’s check this story! It’s make me cry',
          author:{
            name: 'Dara Adhelia',
            userName: 'daracakep',
            proPic: 'avatar.png',
            verified: true
          },
          sharedPost:{
            id: 1,
            title: 'What is Lorem Ipsum?',
            img: 'p1.jpeg',
            desc: 'Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry\'s standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum',
            originalAuthor:{
              name: 'Jon Doe',
              userName: 'jondoe',
              proPic: 'f4.png',
              verified: true
            }
          },
          postReaction:[],
          postComments:[
            {
              id:1,
              comment:"Comment goes to here.."
            },
            {
              id:2,
              comment:"Comment goes to here.."
            },
            {
              id:3,
              comment:"Comment goes to here.."
            }
          ],
        }
      ]
    }
  },

  methods:{

    postModal() {
      EventBus.$emit('postmodal',true);
    },

    numberFormat(value) {
      if(value>=1000000000000) {
          value=(value/1000000000000)+"TB"
      } else if(value>=1000000000) {
          value=(value/1000000000)+"B"
      } else if(value>=1000000){
          value=(value/1000000)+"M"
      } else if(value>=1000) {
          value=(value/1000)+"K";
      }

      return value;
    },

    relayoutTheGrid() {
      setTimeout(() => {
        var elem = document.querySelector('.grid');
        this.isotope = new Isotope(elem, {
          itemSelector: '.item',
          layoutMode: 'masonry'
        })
      })
    },

    imageProgress() {
       this.relayoutTheGrid();
    }

  },

  created() {
    this.relayoutTheGrid();
  },

  directives: {
      imagesLoaded,
  }

}

</script>


<style type="text/css">

  .item {

      width: 50%;
      -webkit-box-sizing: border-box;
              box-sizing: border-box;
      margin-bottom:30px;
      padding-right: 15px;
      padding-left: 15px;
  }
  
  .home-main-content {
      width: 77%;
      padding: 30px 5% 30px;
      -webkit-box-sizing: border-box;
              box-sizing: border-box;
  }

  .posts-wrap {
      margin-top: 50px;
  }

  .mb-3{
    margin-bottom: 30px;
  }

  /*-- post area css --*/

  .post-single-wrap {
      border-radius: 5px;
      background: #ffffff;
      -webkit-box-shadow: 0px 5px 15px rgba(33,65,99,0.1);
              box-shadow: 0px 5px 15px rgba(33,65,99,0.1);
  }
  .card-header {
      position: relative;
      display: -webkit-box;
      display: -ms-flexbox;
      display: flex;
      -webkit-box-pack: justify;
          -ms-flex-pack: justify;
              justify-content: space-between;
      -webkit-box-align: center;
          -ms-flex-align: center;
              align-items: center;
      padding: 15px 20px;
  }


  .autohor-details {
      display: -webkit-box;
      display: -ms-flexbox;
      display: flex;
      -webkit-box-align: center;
          -ms-flex-align: center;
              align-items: center;
  }
  .autohor-details > img {
      width: 40px;
      height: 40px;
      border: 4px solid #00c6c6;
      border-radius: 100%;
      padding: 3px;
      margin-right: 15px;
  }
  .author-name h2 {
      color: #214163;
      font-family: Lato;
      font-size: 17px;
      font-weight: 700;
      line-height: 20px;
      letter-spacing: 0.5357143px;
  }

  .author-name h2 img {
      position: relative;
      top: 5px;
  }

  .author-name > p {
      color: #214163;
      font-size: 13px;
      line-height: 30px;
      letter-spacing: 0.5416667px;
      margin: 0px;
  }

  .post-setting {
      z-index: 1;
  }
  .post-setting .dropdown-menu:after {
     -webkit-box-shadow: -1px -1px 0px #dddddd87 !important; 
     box-shadow: -1px -1px 0px #dddddd87 !important; 
  }

  .post-setting button.dropdown-sm{
      background: transparent !important; 
      width: 35px !important; 
      height: 35px !important; 
      border-radius: 5px !important; 
      border: solid 1px #214163 !important; 
      line-height: 0px !important; 
      outline: none;
      cursor: pointer;
      padding: 0;
      text-align: center;
  }

  .card-body .story-description{
    padding:20px;
  }
  .card-body .story-description {
    padding: 0;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    position: absolute;
    top: 7%;
    width: 90%;
    height: 85%;
    overflow: hidden;
    left: 5%;
  }

  .story-desc-wrap{
    position: relative;
    cursor: pointer;
  }

  .story-desc-wrap img{
   width: 100%;
  }

  .story-description h2 {
      color: #d9d9d9;
      font-size: 22px;
  }
  .story-description p {
      color: #f2f2f2;
      font-size: 17px;
      letter-spacing: 1.2px;
      font-family: Lato;
      font-size: 18px;
      font-weight: 400;
      line-height: 34px;
      letter-spacing: 1.5px;
      margin: 16px 0 0 0;
  }


  .card-footer{
    padding: 15px 20px;
  }
  .footer-social{
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-pack: justify;
        -ms-flex-pack: justify;
            justify-content: space-between;
    -webkit-box-align: center;
        -ms-flex-align: center;
            align-items: center;
  }

  .story-footer ul,
  .footer-social ul {
      margin: 0;
      padding: 0;
      list-style: none;
      display: -webkit-box;
      display: -ms-flexbox;
      display: flex;
      -webkit-box-align: center;
          -ms-flex-align: center;
              align-items: center;
  }

  .story-footer ul {
      -webkit-box-pack: justify;
      -ms-flex-pack: justify;
      justify-content: space-between;
      -webkit-box-align: center;
      -ms-flex-align: center;
      align-items: center;
      padding-top: 15px;
      padding-bottom: 8px;
  }
  .footer-social ul li {
    /*margin-right: 18px;*/
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
        -ms-flex-align: center;
            align-items: center;
    cursor: pointer;
    padding: 4px 7px;
    -webkit-transition: .5s;
    -o-transition: .5s;
    transition: .5s;
    border-radius: 3px;

  }
  .footer-social ul li:last-child{
    margin-right: 0px;
  }
  .footer-social ul li span{
    margin-left: 4px;
    margin-top: -1px;
  }

  .footer-social ul li:nth-child(3) img {
      width: 17px;
  }

  .share-btn {
    font-weight: 700;
    letter-spacing: 0.5318182px;
    cursor: pointer;
    padding: 6px;
    -webkit-box-sizing: border-box;
            box-sizing: border-box;
    -webkit-transition: .5s;
    -o-transition: .5s;
    transition: .5s;
    border-radius: 3px;
  }
  .footer-social ul li:hover,
  .share-btn:hover {
      background: #e5e5e5c7;
  }
  .share-btn img {
      margin-right: 5px;
  }
  .story-wrapper .author-name > p {
      opacity: .6;
  }
  .story-footer-desc a p {
    color: #214163;
    font-size: 15px;
    line-height: 24px;
    letter-spacing: 0.46875px;
    margin: 0 0 0 5px;
  }
  .story-footer ul li{
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
        -ms-flex-align: center;
            align-items: center;
    cursor: pointer;    
    padding: 4px 3px;
    border-radius: 5px;
    -webkit-transition: .5s;
    -o-transition: .5s;
    transition: .5s;
  }
  .story-footer ul li:hover{
    background: #e5e5e5c7;
  }
  .story-footer ul li img {
      margin-right: 5px;
  }
  .story-tag button {
      margin-left: 6px;
      border-radius: 15px;
      border: solid 1px #214163;
      padding: 5px 14px 7px;
      opacity: 0.4036691;
      margin-left: 4px;
      font-size: 12px;
      font-weight: 700;
      line-height: 14px;
      letter-spacing: 0.4285714px;
      cursor: pointer;
      background: transparent;
      -webkit-transition: .5s;
      -o-transition: .5s;
      transition: .5s;
      outline: none;    margin-bottom: 5px;
  }

  .story-tag button:hover {
      background: #00c6c6;
      color: #fff;
      border-color: #00c6c6;
  }

  .post-single-wrap.addPost {
      padding: 30px 30px;
      display: -webkit-box;
      display: -ms-flexbox;
      display: flex;
      -webkit-box-orient: vertical;
      -webkit-box-direction: normal;
          -ms-flex-direction: column;
              flex-direction: column;
      -webkit-box-pack: center;
          -ms-flex-pack: center;
              justify-content: center;
      -webkit-box-sizing: border-box;
              box-sizing: border-box;
      border-radius: 20px;
      position: relative;
      overflow:hidden;
  }
  .post-single-wrap.addPost h2 {
      color: #ffffff;
      font-family: "Playfair Display";
      font-size: 18px;
      line-height: 24px;
      letter-spacing: 1.285714px;
      z-index: 1
  }

  .post-single-wrap.addPost p {
      color: #ffffff;
      font-family: Lato;
      font-size: 14px;
      font-weight: 400;
      line-height: 24px;
      letter-spacing: 0.35px;
      margin: 15px 0 0 0;
      z-index: 1
  }
  .post-single-wrap.addPost:after,
  .post-single-wrap.addPost:before{
    position: absolute;
    content: "";
    width: 100%;
    height: 100%
  }

  .post-single-wrap.addPost:before{
    top: -20px;
    left: -25px;
    width: 100px;
    height: 100px;
    background: #ffffff2e;
    border-radius: 100%;
  }
  .post-single-wrap.addPost:after{
    bottom: 0;
    right: 0;
    background-image: url(../../assets/icon/oval2.svg);
    background-repeat: no-repeat;
    background-position: bottom right;
  }
  .share-post {
      padding: 0px 20px;
  }
  .share-post>.card-header {
      border: 1px solid rgba(33, 65, 99, .2);
      border-top-left-radius: 5px;
      border-top-right-radius: 5px;
  }
  .share-post .autohor-details > img {
      width: 30px;
      height: 30px;
      border: 3px solid #00c6c6;
      padding: 1px;
      margin-right: 10px;
  }

  .share-post .author-name h2{
      font-size: 14px;
      letter-spacing: 0.5px;
  }
  .share-post .author-name p{
    font-size: 12px;
    line-height: 14px;
  }
  .share-desc {
      padding: 5px 20px 20px;
  }

  .share-desc h3 {
      font-family: Lato;
      font-size: 15px;
      letter-spacing: 0.3125px;
      line-height: 22px;
  }
  .share-post .card-footer{
    padding-right: 0px;
    padding-left: 0px;
  }

  .addPost .viewMore {
      color: #ffffff;
      font-size: 14px;
      font-weight: 700;
      line-height: 17px;
      margin-top: 25px;
      cursor: pointer !important;
      position: relative;
      z-index: 1;
  }

  .addPost .viewMore:hover {
      text-shadow: 0px 0px 10px rgba(113, 113, 113, 0.98);
  }

  .post-single-wrap.slider-post {
      border-radius: 15px;
      padding: 20px 30px 20px;
  }

  .slider-post .card-body h2 {
      font-family: "Playfair Display";
      font-size: 22px;
      letter-spacing: 1.285714px;
  }
  .slider-post .card-body p {
    color: #214163;
    font-size: 14px;
    line-height: 26px;
    letter-spacing: 0.35px;
  }

  .slide-box {
      display: -webkit-box;
      display: -ms-flexbox;
      display: flex;
      overflow: auto;
      padding-bottom: 20px;
  }

  .slide-box-single {
      position: relative;
      -webkit-box-flex: 0;
          -ms-flex: 0 0 50%;
              flex: 0 0 50%;
      max-width: 130px;
      -webkit-box-sizing: border-box;
      box-sizing: border-box;
      height: 160px;
      padding: 20px 20px 25px 20px;
      border-radius: 15px;
      margin-right: 15px;
      display: -webkit-box;
      display: -ms-flexbox;
      display: flex;
      -webkit-box-align: end;
          -ms-flex-align: end;
              align-items: flex-end;
  }

  .slide-box-single > img{
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
  }

  .slide-box-single h3{
    color: #ffffff;
    font-size: 16px;
    letter-spacing: 0.5714286px;
    position: relative;
    z-index: 1;
  }



  .slide-box::-webkit-scrollbar {
    width: 2px !important;
    margin-top: 100px !important;
    height: 8px;
  }
  .slide-box::-webkit-scrollbar-thumb {
      background: #A5B5C9;
      border-radius: 10px;
      margin: 10px 0px;
  }
  .slide-box::-webkit-scrollbar-track {
      -webkit-box-shadow: inset 0 0 9px #DAE3EE;
      box-shadow: inset 0 0 9px #DAE3EE;
      border-radius: 10px;
      margin: 20px 0 0 0;
  }


  /** reaction css **/
  @media only screen and (min-width: 1200px) and (max-width: 1400px) {

    .card-body .story-description {
        top: 5%;
        height: 90%;
    }
    .story-description h2 {
        font-size: 18px;
    }
    .story-description p {
        font-size: 14px;
        line-height: 21px;
        margin-top: 7px;
    }

    .author-name > p {
        font-size: 13px;
        line-height: 20px;
        margin: 0px;
    }

    .autohor-details > img {
        width: 30px;
        height: 30px;
        border: 2px solid #00c6c6;
        padding: 2px;
        margin-right: 7px;
    }

    .story-footer-desc a p {
        font-size: 14px;
        line-height: 21px;
    }
    .story-footer ul li img {
        margin-right: 1px;
    }
    .story-footer ul li>span {
        font-size: 12px;
    }
    .story-tag button {
        padding: 5px 7px 7px;
    }

   
    .single-badge-content>h3 {
        font-size: 13px;
        line-height: 10px;
    }

    .humor-topcs-sl {
        width: 40px;
        height: 30px;
        font-size: 14px;
    }
    .humor-topcs-details>a {
        font-size: 13px;
        font-weight: 500;
        margin-top: 0px;
    }

    .humor-topcs-btm {
        margin-top: 4px;
    }

  }



  @media only screen and (max-width: 1199px) {

    .home-main-content {
        width: 65%;
    }
    .item {
        width: 100%;
    }

  }

  @media only screen and (max-width: 1092px) {


    .home-main-content {
        width: 60%;
    }


  }
  @media only screen and (max-width: 991px) {

    .story-description p {
        font-size: 15px;
        line-height: 30px;
    }
  }
  @media only screen and (max-width: 890px) {


    .story-footer ul li > img {
        margin-right: 0px;
    }

    .story-footer ul li > span {
        font-size: 13px;
    }
  }
  @media only screen and (max-width: 820px) {
    .single-badge-content > span {
        font-size: 10px;
        opacity: 0.4;
    }
    .story-description p {
        font-size: 13px;
        line-height: 22px;
        margin-top: 5px;
    }
    
  }


  /*-- mobila layout --*/
  @media only screen and (max-width: 768px) {
      .story-description p {
          font-size: 14px;
          line-height: 23px;
      }
      .post-type{
        display: none;
      }

      .posts-wrap{
            margin-top: 0px;
      }
      .home-main-content {
          padding: 0px;
      }

  }


  @media only screen and (max-width:  415px) {
    .story-description p {
        font-size: 12px;
        line-height: 20px;
    }

  }

  @media only screen and (max-width:  400px) {

    .story-footer ul {
        -webkit-box-orient: vertical;
        -webkit-box-direction: normal;
            -ms-flex-direction: column;
                flex-direction: column;
        -webkit-box-align: start;
            -ms-flex-align: start;
                align-items: flex-start;
        margin-bottom: 5px;
    }


    @media only screen and (max-width:  360px) {
      .story-description p {
          font-size: 10px;
          line-height: 16px;
      }

    }

  }
</style>